<div class="filter-editor">

  <div class="btn-toolbar" role="toolbar">
      @if (predicate) {
          <div class="btn-group filter-group">
                  <composite-predicate
                          [topLevel]="true"
                          [predicate]="predicate"
                          [orgUnits]="orgUnits"
                          (orgUnitValueChange)="onUpdateOrgUnitValue($event.value, $event.id)"
                          (combinatorChange)="onUpdateCombinator($event.combinator, $event.id)"
                          (removePredicate)="onRemovePredicate($event)"
                          (orgUnitValueAdd)="onAddFilterInGroup($event.orgUnitType, $event.id)">
                  </composite-predicate>
          </div>
      }

      <div class="btn-group add-group">
          <button class="btn btn-secondary" type="button" [matMenuTriggerFor]="menu">
              <i class="far fa-plus"></i> {{'add_filter' | translate}}
          </button>
          <mat-menu #menu="matMenu">
            @for (orgUnitType of orgUnitTypes; track orgUnitType) {
            <span mat-menu-item (click)="addOrgUnitType(orgUnitType)">{{ orgUnitType }}</span>
            }
          </mat-menu>
      </div>
  </div>
</div>



